import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'
import { SkeletonUnit } from '../../SkeletonUnit'
import {
  breakpointsHeightDescription,
  breakpointsMarginDescription,
} from './breakpoints'

export interface IChannelDescriptionSkeletonUnitProps extends ISkeletonUnitProps {
  breakpointsHeight?: {}
  breakpointsMargin?: {}
}

export const ChannelDescriptionSkeletonUnit = ({
  width = '100%',
  breakpointsMargin = breakpointsMarginDescription,
  breakpointsHeight = breakpointsHeightDescription,
  ...rest
}: IChannelDescriptionSkeletonUnitProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const validHeight = breakpointsHeight
    ? getValueForBreakpoint(clientWidth, breakpointsHeight)
    : rest.height
  const validMargin = breakpointsMargin
    ? getValueForBreakpoint(clientWidth, breakpointsMargin)
    : rest.margins

  return (
    <SkeletonUnit
      width={width}
      height={validHeight}
      margins={validMargin}
      {...rest}
    />
  )
}
